import {
  Auth,
  browserLocalPersistence,
  connectAuthEmulator,
  getAuth,
  setPersistence,
  signInWithCustomToken,
} from "firebase/auth";

import {
  app,
  resolveEmulatorAddress,
  useEmulator,
} from "~/integrations/firebase/app";
import { logError } from "~/shared/services/error-reporting";

declare global {
  interface E2eWindow {
    signIn?: (customToken: string) => Promise<void>;
  }
}

export const auth: Auth = getAuth(app);

setPersistence(auth, browserLocalPersistence).catch(logError);

auth.tenantId = import.meta.env.VITE_FIREBASE_AUTH_TENANT_ID || null;

if (useEmulator) {
  auth.tenantId = "metadata-local-tenant";
  const { host, port } = resolveEmulatorAddress("auth");

  connectAuthEmulator(auth, `http://${host}:${port}`, {
    disableWarnings: true,
  });
}

// Lets the E2E setup sign in through this instance. Safe in production: only a
// custom token minted with the service account signs anyone in.
if (window.e2e) {
  window.e2e.signIn = async (customToken) => {
    await signInWithCustomToken(auth, customToken);
  };
}
